import { useTranslation } from "react-i18next";
import { ReactNode } from "react";
import { StripePad } from "@/api/opb/opbTypes";
import {
  Tag,
  TagVariant,
  TextButton,
} from "@industriousoffice/react-components";

interface StripePadInfoProps {
  paymentMethod: StripePad;
  withEdit?: boolean;
  footer?: ReactNode;
}

export function StripePadInfo({
  paymentMethod,
  withEdit,
  footer,
}: StripePadInfoProps) {
  const { t } = useTranslation("paymentMethods");

  return (
    <>
      <div className="pt-1 grow-0">
        <div className="w-9 h-5 border rounded-sm text-xs flex justify-center items-center font-medium border-grey-80">
          {t("PAD")}
        </div>
      </div>
      <div className="pl-3 text-left relative grow shrink-0 w-24 flex-wrap">
        <div>{paymentMethod.bankName || null}</div>
        <div className="flex items-center">
          <div className="capitalize">{paymentMethod.type}</div>
          {paymentMethod.default && (
            <Tag
              text={t("Default")}
              variant={TagVariant.Info}
              className="mx-2 rounded-sm font-normal h-5"
            />
          )}
        </div>
        <div>
          <span className="font-bold">{paymentMethod.bankABACode}</span>
          {paymentMethod.bankAccountNumber}
        </div>
        {withEdit ? (
          <TextButton
            type="button"
            className="absolute top-1 right-3"
            data-testid={`ach-edit_${paymentMethod.id}-btn`}
          >
            {t("Edit")}
          </TextButton>
        ) : null}
        {footer}
      </div>
    </>
  );
}
